<script lang="ts">
    import type { Deal, SocialProof, TileImage } from '@shared/types/types';
    import ProductImage from '@tile/components/product-image/ProductImage.svelte';
    import type { ImageAspectRatio, ImageLoadingOptions } from '@tile/components/product-image/types.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import type { ExperimentGroups } from '@tilelist/domain/experiments/Experiments.ts';
    import ProductImageE3867 from '@tilelist/layouts/experiments/e3867/product-image/ProductImage.svelte';
    import ProductImageCarousel from '@tilelist/layouts/experiments/e3891/product-image-carousel/ProductImageCarousel.svelte';

    interface Props {
        images: TileImage[];
        fallbackImage: TileImage;
        variationId: string;
        detailPageLink: string;
        imageLoadingOptions: ImageLoadingOptions;
        onClick?: (event: Event) => void;
        onImageChange?: () => void;
        deal?: Deal;
        aspectRatio?: ImageAspectRatio;
        rule?: string;
        brand?: string;
        title?: string;
        socialProof?: SocialProof;
        shouldDim?: boolean;
    }

    let {
        images,
        fallbackImage,
        variationId,
        detailPageLink,
        imageLoadingOptions,
        onClick,
        onImageChange,
        deal,
        aspectRatio,
        rule,
        brand,
        title,
        socialProof,
        shouldDim,
    }: Props = $props();

    const onex = injectWiring().onex;

    const additionalImagesMapping: Record<ExperimentGroups['ADDITIONAL_IMAGES'], boolean> = {
        E3891A: false,
        E3891B: true,
    };

    const showAdditionalImages = $derived(onex.matchGroup('ADDITIONAL_IMAGES', additionalImagesMapping));
    const cleanTileActive = $derived(onex.isExperimentGroup('CLEAN_TILE_V2', 'E3867B'));
</script>

{#snippet carousel(linkType: 'image' | 'tile', deal?: Deal, socialProof?: SocialProof, rule?: string)}
    <ProductImageCarousel
        {images}
        {fallbackImage}
        {variationId}
        {detailPageLink}
        brand={brand || ''}
        title={title || ''}
        {imageLoadingOptions}
        {onClick}
        {onImageChange}
        {deal}
        {aspectRatio}
        {socialProof}
        {rule}
        size="100"
        {shouldDim}
        {linkType}
    />
{/snippet}

{#if showAdditionalImages}
    {#if cleanTileActive}
        <div data-secondary-action>
            {@render carousel('tile')}
        </div>
    {:else}
        {@render carousel('image', deal, socialProof, rule)}
    {/if}
{:else if cleanTileActive}
    <ProductImageE3867 image={fallbackImage} {variationId} {imageLoadingOptions} {aspectRatio} {shouldDim} />
{:else}
    <ProductImage
        {variationId}
        image={fallbackImage}
        {socialProof}
        {detailPageLink}
        {onClick}
        {deal}
        {imageLoadingOptions}
        {aspectRatio}
        {rule}
        {shouldDim}
    />
{/if}
